<template>
    <span class="timestamp">
        <b-badge v-if="variant" :variant="variant">{{ formattedDate }}</b-badge>
        <template v-else>{{ formattedDate }}</template>
    </span>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'

/**
 * Component to display a date/time in the local timezone - provides some smart
 * defaults without having to futz with date formatting strings.
 */
export default Vue.extend({
    name: 'timestamp',
    props: {
        date: String,
        includeTime: { type: Boolean, default: true },
        includeYear: { type: Boolean, default: false },
        dateWarning: { type: Boolean, default: false }
    },
    computed: {
        formattedDate () {
            // empty (or invalid) date
            if ((this.date === undefined) || !moment(this.date).isValid()) {
                return ''
            }

            let format = 'MMM D'    // Jan 26
            // add year only if it's not the current year (unless specifically requested)
            if (this.includeYear || !moment(this.date).isSame(new Date(), 'year')) {
                format += ' \'YY'    // '21
            }
            if (this.includeTime) {
                format += ' h:mm A' // 6:21 PM
            }

            return moment.utc(this.date).local().format(format)
        },
        variant () {
            const dateDiff = moment(this.date).diff(moment(), 'days')
            if (!this.dateWarning) {
                return null
            } else if (dateDiff < 30) {
                return 'danger'
            } else if (dateDiff < 90) {
                return 'warning'
            } else {
                return 'primary'
            }
        }
    },
})
</script>
